export const tr = {
    'freelancer-is-busy': 'meşgul',
    'freelancer-is-busy-is-owner': 'Meşgulüm',
    'freelancer-is-cooperating': 'Çözüm ortaklığı içerisindesiniz',
    'freelancer-is-free': 'müsait',
    'freelancer-is-free-is-owner': 'Müsaitim'
};
